export const ADD_NEW_PRODUCT = 'ADD_NEW_PRODUCT';

export const addNewProduct = (product) => {
  return {
    type: ADD_NEW_PRODUCT,
    payload: product
  }
};